import React from 'react';

/**
 * @param {{ variant?: 'warm' }} props - "warm" = audit gratuit (bleu clair), sinon violet/bleu (reste de l'app)
 */
export default function BackgroundOroles({ variant }) {
  const isWarm = variant === 'warm';

  if (isWarm) {
    return (
      <>
        {/* Fond très léger, à peine teinté cyan */}
        <div className="pointer-events-none select-none fixed inset-0 z-0" style={{ background: '#f8fcfc' }} />
        {/* Orbes : même structure, flou — tons cyan très discrets */}
        <div className="pointer-events-none select-none fixed top-[10vh] left-[-250px] w-[900px] h-[900px] rounded-full z-0" style={{ background: '#00dede', opacity: 0.08, filter: 'blur(120px)' }} />
        <div className="pointer-events-none select-none fixed top-[-200px] right-[-200px] w-[700px] h-[700px] rounded-full z-0" style={{ background: '#5ee7e7', opacity: 0.07, filter: 'blur(120px)' }} />
        <div className="pointer-events-none select-none fixed bottom-[-120px] right-[-120px] w-[400px] h-[400px] rounded-full z-0" style={{ background: '#9ef0f0', opacity: 0.06, filter: 'blur(80px)' }} />
      </>
    );
  }

  return (
    <>
      <div className="pointer-events-none select-none fixed top-[10vh] left-[-250px] w-[900px] h-[900px] rounded-full z-0" style={{ background: '#82455c', opacity: 0.13, filter: 'blur(120px)' }} />
      <div className="pointer-events-none select-none fixed top-[-200px] right-[-200px] w-[700px] h-[700px] rounded-full z-0" style={{ background: '#2563eb', opacity: 0.12, filter: 'blur(120px)' }} />
      <div className="pointer-events-none select-none fixed bottom-[-120px] right-[-120px] w-[400px] h-[400px] rounded-full z-0" style={{ background: '#694150', opacity: 0.10, filter: 'blur(80px)' }} />
    </>
  );
} 